
import endpoints from './endpoints';
import externalEndpoints from './externalEndpoints';
import environments from './environments';
import routes from './routes';
import states from './states';
import mode from './mode';

const ENV = {
    PRODUCTION: mode === environments.CUSTOM || mode === environments.PRODUCTION,
    DEVELOPMENT: mode === environments.DEVELOPMENT,
    CUSTOM: mode === environments.CUSTOM,
    EXPLICIT_PRODUCTION: mode === environments.PRODUCTION
};

globalThis.__ENV__ = __MODE__ === 'production' && __NOT_JESTABLE__ ? Object.freeze(ENV) : ENV;

export const configs = {
    routes: routes[mode],
    endpoints,
    externalEndpoints,
    states,
    mode,
    ENV
};